module.exports = __webpack_public_path__ + "img/fraud-5.46a01889.jpg";